// extracted by mini-css-extract-plugin
export default {"noContactsImage":"NoContacts_noContactsImage__L-7Tk"};